import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FnCheckboxEventFilter, FnCheckboxFilterItem, FnCheckboxFilterOption, FnLoaderService, FnLoaderType, FnModalService, FnToasterService } from 'foundation';
import { DashboardCommentModelComponent } from './dashboard-comment-model/dashboard-comment-model.component';
import { DashboardInfoModelComponent } from './dashboard-info-model/dashboard-info-model.component';
import { DashboardResolvedModelComponent } from './dashboard-resolved-model/dashboard-resolved-model.component';
import { DashboardForwordModelComponent } from './dashboard-forword-model/dashboard-forword-model.component';
import { DashboardMailModelComponent } from './dashboard-mail-model/dashboard-mail-model.component';
import { PosHttpService } from '../../services/pos.http.service';
import { DashboardChangeSeverityModelComponent } from './dashboard-change-severity-model/dashboard-change-severity-model.component';
import { DashboardAllCommentModelComponent } from './dashboard-all-comment-model/dashboard-all-comment-model.component';
import { EOTeam } from '../../modal/entity.modal';
import { DashboardDisableModelComponent } from './dashboard-disable-model/dashboard-disable-model.component';
import { Router } from '@angular/router';
import { Clipboard } from '@angular/cdk/clipboard';
import { DashboardAllResolvedComponentComponent } from './dashboard-all-resolved-component/dashboard-all-resolved-component.component';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardComponent implements OnInit, OnDestroy {
  tableData: Array<any> = [];
  filteredTableData: Array<any> = [];
  newFilterData: Array<any> = [];
  eventCheckboxFilterArray: Array<FnCheckboxEventFilter> = [];
  isFilterApplied = false;
  FILTER_KEYS: Record<string, string> = {};
  tableSize = false;
  totalAlerts = 0;
  interval: ReturnType<typeof setInterval> | null = null;
  interval1: ReturnType<typeof setInterval> | null = null;
  count!: number;
  count1!: number;
  count2!: number;
  isLoadMain: boolean = false;
  isLoading3: boolean = false;
  isLoading1: boolean = false;
  isLoading2: boolean = false;
  filterEmpArray: number[] = [];
  paginationMap = {
    currentPage: 1,
    totalSize: 0,
    pageSize: 15,
  };
  teamArray = [];
  selectTeam: string[] = [];
  team: string[] = [];
  private isInitTeamSet = false;
  searchTerm = '';
  isAllSelected: boolean = false;
  isSelected: boolean = false;
  sev1 = {
    total: 0,
    notViewed: 0,
    escalated: 0,
  };
  sev2 = {
    total: 0,
    notViewed: 0,
    escalated: 0,
  };
  sev3 = {
    total: 0,
    notViewed: 0,
    escalated: 0,
  };
  disabled: any;
  currentPage: string = '';
  isButtonDisabled: boolean = false;
  isRefreshing: boolean = false;
  disablePage: boolean = false;

  constructor(
    private clipboard: Clipboard,
    private fnModalSvcs: FnModalService,
    private dialogSvcs: FnModalService,
    private loader: FnLoaderService,
    private posHttpSvcs: PosHttpService,
    private toaster: FnToasterService,
    private router: Router
  ) {
    this.loader.hide();
    this.loader.setloaderType(FnLoaderType.MANUAL);
  }

  ngOnInit() {
    this.loadTeamArray();
    this.alertData(true);
    this.startRepeatingTask();
    this.setBackgroundColor();
    this.setBackgroundtotalColor();
  }

  colors: string[] = ['#79B0B0', '#b6a6a6', '#AA8EA7', '#77A9D1', '#b9c09b', '#70709f', '#B1B37D'];

  getForwardedColor(): string {
    const today = new Date().getDay();
    return this.colors[today];
  }

  setBackgroundtotalColor() {
    const today: number = new Date().getDay();
    const element = document.querySelector('.element-style') as HTMLElement;
    if (element) {
      element.style.backgroundColor = this.colors[today];
    }
  }

  setBackgroundColor() {
    const today: number = new Date().getDay();
    const element = document.querySelector(
      '.element-styleChange'
    ) as HTMLElement;
    if (element) {
      element.style.backgroundColor = this.colors[today];
    }
  }

  loadTeamArray() {
    this.posHttpSvcs
      .authGet('v1/ui/getEOTeamArray', 'getEOTeamArray')
      .subscribe((resp) => {
        if (resp.isError) {
          this.toaster.error('EOTeamArray is not loaded');
        }
        const array = resp.data;
        this.teamArray = array;
      });
  }

  private alertData(reload: boolean) {
    this.posHttpSvcs
      .authPost('v1/ui/loadAlerts', 'loadAlerts', this.filterEmpArray)
      .subscribe((resp: any) => {
        if (resp.isError) {
          this.toaster.error('Invalid Data');
          return;
        }
        this.totalAlerts = resp.data.totalAlerts;
        this.sev1 = resp.data.Sev1;
        this.sev2 = resp.data.Sev2;
        this.sev3 = resp.data.Sev3;
        this.disabled = resp.data.disabled;
        if (!this.isInitTeamSet) {
          this.selectTeam = resp.data.team;
          this.isInitTeamSet = true;
        }
        if (reload) {
          this.tableData = resp.data.alerts;
          this.currentPage = 'Sev 1';
          this.formatData();
        } else {
          this.currentPage === 'Total Alerts'
            ? this.openTotal()
            : this.loadAlertSev(this.currentPage);
        }
        this.team = resp.data.team;
      });
  }

  reloadAllAlert() {
    if (this.isButtonDisabled) {
      return;
    }
    this.isButtonDisabled = true;
    this.isRefreshing = true;
    setTimeout(() => {
      this.isButtonDisabled = false;
      this.isRefreshing = false;
    }, 5000);
    this.isLoadMain = true;
    this.isLoading1 = true;
    this.isLoading2 = true;
    this.isLoading3 = true;
    this.closeEsc();
    this.isAllSelected = false;
    this.paginationMap.currentPage = 1;
    this.posHttpSvcs
      .authGet('v1/ui/loadAllAlerts', 'loadAllAlerts')
      .subscribe((resp: any) => {
        this.alertData(false);
        setTimeout(() => {
          this.isLoadMain = false;
          this.isLoading1 = false;
          this.isLoading2 = false;
          this.isLoading3 = false;
        }, 2000);
      });
  }

  filterAlert() {
    if (this.selectTeam.length === 0) {
      this.filterEmpArray = [];
      return;
    }
    this.filterEmpArray = [this.selectTeam] as any;
    this.reloadAllAlert();
  }

  openTotal() {
    this.closeEsc();
    this.isAllSelected = false;
    this.paginationMap.currentPage = 1;
    this.isFilterApplied = false;
    this.posHttpSvcs
      .authPost('v1/ui/loadTotalAlerts', 'loadTotalAlerts', this.filterEmpArray)
      .subscribe((resp: any) => {
        if (resp.isError) {
          this.toaster.error('Invalid Data');
          return;
        }
        this.currentPage = 'Total Alerts';
        this.disablePage = false;
        this.tableData = resp.data.alerts;
        this.formatData();
      });
  }

  getTotalCount(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isLoadMain = true;
    this.posHttpSvcs
      .authPost('v1/ui/loadTotalCount', 'loadTotalCount', this.filterEmpArray)
      .subscribe((resp: any) => {
        if (resp.isError) {
          this.toaster.error('Invalid Data');
          return;
        }
        this.isLoadMain = false;
        this.totalAlerts = resp.data.totalAlerts;
      });
  }

  loadAlertSev(severity: string) {
    this.closeEsc();
    this.paginationMap.currentPage = 1;
    this.isAllSelected = false;
    const pktData = {
      severity: severity,
      teams: this.filterEmpArray,
    };
    this.posHttpSvcs
      .authPost('v1/ui/loadAlertSev', 'loadAlertSev', pktData)
      .subscribe((resp) => {
        if (resp.isError) {
          this.toaster.error('Invalid Data');
          return;
        }
        if (severity == 'Sev 1') {
          this.isLoading1 = false;
          this.currentPage = 'Sev 1';
        }
        if (severity == 'Sev 2') {
          this.isLoading2 = false;
          this.currentPage = 'Sev 2';
        }
        if (severity == 'Sev 3') {
          this.isLoading3 = false;
          this.currentPage = 'Sev 3';
        }
        this.tableData = resp.data.alerts;
        this.disablePage = false;
        this.formatData();
      });
  }

  getSevCount(severity: string, event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.fetchSevCount(severity);
  }

  startRepeatingTask() {
    this.interval = setInterval(() => {
      this.fetchSevCount('Sev 1');
    }, 120000);
    this.interval1 = setInterval(() => {
      this.getTotalCount();
      this.fetchSevCount('Sev 2');
      this.fetchSevCount('Sev 3');
      this.disableAlert();
    }, 300000);
  }

  fetchSevCount(severity: string) {
    if (severity == 'Sev 1') {
      this.isLoading1 = true;
    }
    if (severity == 'Sev 2') {
      this.isLoading2 = true;
    }
    if (severity == 'Sev 3') {
      this.isLoading3 = true;
    }
    const rqst = {
      severity: severity,
      teams: this.filterEmpArray,
    };
    this.posHttpSvcs
      .authPost('v1/ui/loadSeverityCount', 'loadSeverityCount', rqst)
      .subscribe((resp) => {
        if (resp.isError) {
          this.toaster.error('Invalid Data');
          return;
        }
        if (severity == 'Sev 1') {
          this.isLoading1 = false;
          this.sev1 = resp.data.severity;
        }
        if (severity == 'Sev 2') {
          this.isLoading2 = false;
          this.sev2 = resp.data.severity;
        }
        if (severity == 'Sev 3') {
          this.isLoading3 = false;
          this.sev3 = resp.data.severity;
        }
      });
  }

  disabledAlerts() {
    this.closeEsc();
    this.isAllSelected = false;
    this.paginationMap.currentPage = 1;
    this.disablePage = true;
    this.posHttpSvcs
      .authPost('v1/ui/disabledAlerts', 'disabledAlerts', this.filterEmpArray)
      .subscribe((resp: any) => {
        if (resp.isError) {
          this.toaster.error('Invalid Data');
          return;
        } else {
          this.tableData = resp.data;
          this.currentPage = 'Disabled Alerts';
          this.formatData();
        }
      });
  }

  disableAlert() {
    this.posHttpSvcs
      .authGet('v1/ui/endingAlerts', 'endingAlerts')
      .subscribe((resp) => {

        if (resp.data > 0) {
          this.toaster.error(
            resp.data + ' Alert(s) about to re-appear',
            '',
            {
              timeOut: 300000,
              extendedTimeOut: 300000,
              closeButton: true,
            }
          );
        }
      });
  }

  openEsc() {
    this.tableSize = true;
  }

  closeEsc() {
    this.tableSize = false;
  }

  openEscSev(severity: string) {
    const rqst = {
      severity: severity,
      teams: this.filterEmpArray,
    };
    this.posHttpSvcs
      .authPost('v1/ui/loadEscSev', 'loadEscSev', rqst)
      .subscribe((resp) => {
        if (resp.isError) {
          this.toaster.error('Invalid Data');
          return;
        }
        this.currentPage = 'Forwarded ' + severity;
        this.tableData = resp.data.alerts;
        this.disablePage = false;
        this.formatData();
      });
  }

  filterEventCheckboxData(isFilterApplied: any) {
    this.isFilterApplied = isFilterApplied;
    const selectedFilters = Object.entries(this.FILTER_KEYS).reduce(
      (val, [key, filterKey]) => {
        val[filterKey] = this.getSelectedFilters(filterKey);
        return val;
      },
      {} as Record<string, string[]>
    );

    this.filteredTableData = this.tableData.filter((row) => {
      return Object.entries(selectedFilters).every(
        ([filterKey, selectedValues]) => {
          if (selectedValues.length) {
            return selectedValues.some((range) => {
              const rawValue = row[filterKey];
              const rawStr = rawValue?.toString() ?? '';

              if (/^\d+$/.test(rawStr)) {
                const value = parseInt(rawStr, 10);
                if (range === 'Other') {
                  return value > 100;
                }
                const [start, end] = range.split('-').map(Number);
                return value >= start && value <= end;
              } else {
                return selectedValues.includes(rawStr);
              }
            });
          }
          return true;
        }
      );
    });

    this.paginationMap.currentPage = 1;
    const sourceData = this.isFilterApplied ? this.filteredTableData : this.tableData;
    this.paginationMap.totalSize = Math.ceil(sourceData.length / this.paginationMap.pageSize);
    this.updatePaginatedData();
  }

  private generateFilterKeys() {
    if (this.tableData.length > 0) {
      this.FILTER_KEYS = Object.keys(this.tableData[0]).reduce((val, key) => {
        if (key == 'severity' || key == 'product' || key == 'source' || key == 'sender' || key == 'isEscalated' || key == 'forwarded') {
          val[key.toUpperCase()] = key;
        }
        return val;
      }, {} as Record<string, string>);
    }
  }

  private generateEventCheckboxFilterArray() {
    const filterData: Record<string, string[]> = {};

    const filterKeys = Object.keys(this.FILTER_KEYS);
    for (let k = 0; k < filterKeys.length; k++) {
      const key = filterKeys[k];
      const filterKey = this.FILTER_KEYS[key];

      if (
        filterKey.toLowerCase().includes('time') ||
        filterKey.toLowerCase().includes('date') ||
        !filterKey.toLowerCase().includes('decimal')
      ) {
        const valueSet = new Set<string>();
        for (let i = 0; i < this.tableData.length; i++) {
          const row = this.tableData[i];
          valueSet.add(row[filterKey]?.toString() || '');
        }
        filterData[filterKey] = Array.from(valueSet);
        continue;
      }

      let isIntegerField = true;
      for (let i = 0; i < this.tableData.length; i++) {
        const val = this.tableData[i][filterKey];
        if (!(typeof val === 'number' || /^[0-9]+$/.test(val))) {
          isIntegerField = false;
          break;
        }
      }

      if (isIntegerField) {
        const numericValues: number[] = [];
        for (let i = 0; i < this.tableData.length; i++) {
          const val = parseInt(this.tableData[i][filterKey], 10);
          if (!isNaN(val)) {
            numericValues.push(val);
          }
        }

        const minValue = Math.min(...numericValues);
        const maxValue = Math.max(...numericValues);
        const rangeCount = 10;
        const rangeStep = Math.floor((maxValue - minValue) / rangeCount) || 1;

        const ranges: string[] = [];
        for (let i = 0; i < rangeCount; i++) {
          const start = minValue + i * rangeStep;
          const end = i === rangeCount - 1 ? maxValue : start + rangeStep - 1;
          ranges.push(`${start}-${end}`);
        }
        ranges.push('Other');
        filterData[filterKey] = ranges;
      } else {
        const valueSet = new Set<string>();
        for (let i = 0; i < this.tableData.length; i++) {
          const row = this.tableData[i];
          valueSet.add(row[filterKey]?.toString() || '');
        }
        filterData[filterKey] = Array.from(valueSet);
      }
    }
    const finalFilters: FnCheckboxEventFilter[] = [];
    const filterDataKeys = Object.keys(filterData);

    for (let i = 0; i < filterDataKeys.length; i++) {
      const key = filterDataKeys[i];
      const optionsArray = filterData[key];
      const options: FnCheckboxFilterOption[] = [];

      for (let j = 0; j < optionsArray.length; j++) {
        const value = optionsArray[j];
        options.push(
          new FnCheckboxFilterOption(value, `${j}_${key}`, false, false)
        );
      }

      const allOptionText =
        key === 'isEscalated' ? 'Auto Escalated' : `All ${key}`;
      const allOption = new FnCheckboxFilterOption(
        allOptionText,
        `all_${key}`,
        false,
        false
      );
      finalFilters.push(
        new FnCheckboxEventFilter(
          key.charAt(0).toUpperCase() + key.slice(1),
          key,
          allOption,
          options
        )
      );
    }
    this.eventCheckboxFilterArray = finalFilters;
  }

  getSelectedFilters(filterKey: string): string[] {
    const filter = this.eventCheckboxFilterArray.find(
      (f) => f.primaryKey === filterKey
    );
    return (
      filter?.fnFilterOptionArray
        .filter((option) => option.isSelected)
        .map((option) => option.displayName) || []
    );
  }

  searchOnRows(searchTerm: string): void {
    const keysToSearch = ['alertID', 'alertStartedAt', 'severity', 'product', 'description', 'source', 'sender', 'count', 'duration', 'lastUpdatedAt',
      'viewedBy', 'isEscalated', 'lastActionAt', 'recentComment', 'idenNo', 'uniqueValue',
      'howerCount', 'countForSeverity'];
    this.isFilterApplied = true;
    this.filteredTableData = this.tableData.filter((row) =>
      keysToSearch.some((key) =>
        (row[key] + '').toLowerCase().includes(searchTerm.toLowerCase()))
    );
    this.paginationMap.currentPage = 1;
    this.paginationMap.totalSize = Math.ceil(
      this.filteredTableData.length / this.paginationMap.pageSize
    );
    this.updatePaginatedData();
  }

  onSearchKeyup(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value.trim();

    if (event.key === 'Enter' && searchTerm.length > 0) {
      this.searchOnRows(searchTerm);
    }
  }

  closeSearch(): void {
    this.isFilterApplied = false;
    this.formatData();
    this.updatePaginatedData();
  }

  toggleSelectAll(event: any): void {
    this.isAllSelected = event.target.checked;
    (this.isFilterApplied ? this.filteredTableData : this.tableData).forEach(
      (row) => {
        row.isSelected = this.isAllSelected;
      }
    );
  }

  toggleRowSelection(event: any, rowId: any): void {
    const selectedRow = this.tableData.find((row) => row.primaryKey === rowId);
    if (selectedRow) {
      selectedRow.isSelected = event.target.checked;
    }
    this.isAllSelected = this.tableData.every((row) => row.isSelected);
  }

  copyData(text: string): void {
    if (this.clipboard.copy(text)) {
      this.toaster.success('Successfully Copied!', 'Close');
    }
  }

  copySelectedText(event: MouseEventInit) {
    const selectedText = window.getSelection()?.toString().trim();
    if (selectedText) {
      navigator.clipboard
        .writeText(selectedText)
        .then(() => { })
        .catch((err) => console.error('Failed to copy:', err));
    }
  }

  viewBy(row: any) {
    const pktData = {
      pk: row.primaryKey,
    };
    this.posHttpSvcs
      .authPost('v1/ui/setViewedAlerts', 'setViewedAlerts', pktData)
      .subscribe((resp) => {
        if (resp.isError) {
          this.toaster.error(resp.data);
          return;
        } else {
          row.viewedBy = resp.data.viewedBy;
          row.viewedAt = resp.data.viewedAt;
        }
      });
  }

  infoDetails(row: any) {
    this.posHttpSvcs
      .authPost('v1/ui/extraInfo', 'extraInfo', row.primaryKey)
      .subscribe((resp) => {
        if (resp.isError) {
          this.toaster.error(resp.data);
          return;
        } else {
          row = resp.data;
        }
        const DashboardInfoModel = this.fnModalSvcs.openCustomModal(
          DashboardInfoModelComponent,
          {
            data: {
              extraInfo: row,
            },
            hasBackdrop: true,
            width: '700px',
          }
        );
        DashboardInfoModel.backdropClick().subscribe(() => {
          DashboardInfoModel.close();
        });
      });
  }

  commentsAlert(row: any) {
    const DashboardCommentModal = this.fnModalSvcs.openCustomModal(
      DashboardCommentModelComponent,
      {
        data: {
          comments: row,
        },
        hasBackdrop: true,
        width: '1000px',
      }
    );
  }

  forwardDetails(row: any) {
    const DashboardForwordModel = this.fnModalSvcs.openCustomModal(
      DashboardForwordModelComponent,
      {
        data: {
          forward: row,
        },
        hasBackdrop: true,
        width: '500px',
      }
    );
    DashboardForwordModel.afterClosed().subscribe((doAction) => {
      if (!doAction) {
        this.reloadAllAlert();
      }
    });
  }

  mailDetails(row: any) {
    const DashboardCommentModal = this.fnModalSvcs.openCustomModal(
      DashboardMailModelComponent,
      {
        data: {
          mail: row,
        },
        hasBackdrop: true,
        width: '500px',
      }
    );
  }

  resolveDetails(row: any) {
    const DashboardResolvedModel = this.fnModalSvcs.openCustomModal(
      DashboardResolvedModelComponent,
      {
        data: {
          resolve: row,
        },
        hasBackdrop: true,
        width: '500px',
      }
    );
    DashboardResolvedModel.afterClosed().subscribe((doAction) => {
      if (!doAction) {
        this.reloadAllAlert();
      }
    });
  }

  enable(row: any) {
    const pktData = {
      pk: row.primaryKey,
    };
    this.posHttpSvcs
      .authPost('v1/ui/enableAlerts', 'enableAlerts', pktData)
      .subscribe((resp) => {
        if (resp.isError) {
          this.toaster.error(resp.data);
          return;
        } else {
          this.toaster.success(resp.data);
          this.reloadAllAlert();
          this.disablePage = false;
        }
      });
  }

  disable(row: any) {
    const DashboardDisabledModel = this.fnModalSvcs.openCustomModal(
      DashboardDisableModelComponent,
      {
        data: {
          pk: row.primaryKey,
        },
        hasBackdrop: false,
        width: '500px',
      }
    );
    DashboardDisabledModel.afterClosed().subscribe((doAction) => {
      if (!doAction) {
        this.reloadAllAlert();
      }
    });
  }

  helpDetails(row: any) {
    this.posHttpSvcs
      .authPost('v1/ui/help', 'help', row.primaryKey)
      .subscribe((resp) => {
        if (resp.isError) {
          this.toaster.error(resp.data);
          return;
        } else {
          const url = resp.data;
          window.open(url, '_blank');
        }
      });
  }

  historyDetails(row: any) {
    this.router.navigate(['/app/main/appHistory'], {
      queryParams: {
        pk: row.primaryKey,
        product: row.product,
        idenNo: row.idenNo,
      },
    });
  }

  changeSeverityDetails(row: any) {
    const DashboardCommentModal = this.fnModalSvcs.openCustomModal(
      DashboardChangeSeverityModelComponent,
      {
        data: {
          severity: row,
        },
        hasBackdrop: true,
        width: '500px',
      }
    );
    DashboardCommentModal.afterClosed().subscribe((doAction) => {
      if (!doAction) {
        this.reloadAllAlert();
      }
    });
  }

  paginzationEvent(newPage: number): void {
    if (newPage <= this.paginationMap.totalSize) {
      this.paginationMap.currentPage = newPage;
      this.updatePaginatedData();
    }
  }

  formatData(): void {
    this.generateFilterKeys();
    this.generateEventCheckboxFilterArray();
    this.tableData.forEach((data) => {
      if (data['isSelected'] === undefined) {
        data['isSelected'] = false;
      }
    });
    this.filteredTableData = [...this.tableData];
    const sourceData = this.isFilterApplied ? this.filteredTableData : this.tableData;
    this.paginationMap.totalSize = Math.ceil(
      sourceData.length / this.paginationMap.pageSize
    );
    this.updatePaginatedData();
  }

  updatePaginatedData(): void {
    const startIndex =
      (this.paginationMap.currentPage - 1) * this.paginationMap.pageSize;
    const endIndex = startIndex + this.paginationMap.pageSize;

    const sourceData = this.isFilterApplied ? this.filteredTableData : this.tableData;
    this.newFilterData = sourceData.slice(startIndex, endIndex);
  }

  onPageChange(): void {
    this.updatePaginatedData();
    this.isAllSelected = (this.isFilterApplied ? this.filteredTableData : this.tableData).every((row) => row.isSelected);
  }

  commentsAlertDetails() {
    const pkArray: any = (this.isFilterApplied ? this.filteredTableData : this.tableData).filter((data) => data.isSelected);
    if (pkArray.length != 0) {
      const DashboardCommentModal = this.fnModalSvcs.openCustomModal(
        DashboardAllCommentModelComponent,
        {
          data: {
            comments: pkArray,
          },
          hasBackdrop: true,
          width: '500px',
        }
      );
    } else {
      this.toaster.error('Please select at least one alert');
    }
  }

  viewAllDetails() {
    const pkArray: number[] = (this.isFilterApplied ? this.filteredTableData : this.tableData)
      .filter((data) => data.isSelected)
      .map((data) => data.primaryKey);
    if (pkArray.length != 0) {
      const dialogRef = this.dialogSvcs.openConfirmModal({
        isConformationMdl: true,
        content: `Are you sure you want to acknowledge all alerts?`,
        type: 'danger',
      });
      dialogRef.afterClosed().subscribe((doAction) => {
        if (doAction) {
          const pktData = {
            pk: pkArray,
          };
          this.posHttpSvcs
            .authPost('v1/ui/setViewedAlerts', 'setViewedAlerts', pktData)
            .subscribe((resp) => {
              if (resp.isError) {
                this.toaster.error(resp.data);
                return;
              } else {
                this.reloadAllAlert();
              }
            });
        }
      });
    } else {
      this.toaster.error('Please select Atleast one alert');
    }
  }

  forwardAllDetails() {
    const forwardArray: number[] = (this.isFilterApplied ? this.filteredTableData : this.tableData)
      .filter((data) => data.isSelected)
      .map((data) => data.primaryKey);
    if (forwardArray.length != 0) {
      const DashboardForwordModel = this.fnModalSvcs.openCustomModal(
        DashboardForwordModelComponent,
        {
          data: {
            forward: {
              primaryKey: forwardArray,
            },
          },
          hasBackdrop: true,
          width: '500px',
        }
      );
      DashboardForwordModel.afterClosed().subscribe((doAction) => {
        if (!doAction) {
          this.reloadAllAlert();
        }
      });
    } else {
      this.toaster.error('Please select Atleast one alert');
    }
  }

  resolveAllDetails() {
    const resolveArray: number[] = (this.isFilterApplied ? this.filteredTableData : this.tableData)
      .filter((data) => data.isSelected)
      .map((data) => data.primaryKey);

    if (resolveArray.length != 0) {
      const DashboardResolvedModel = this.fnModalSvcs.openCustomModal(
        DashboardAllResolvedComponentComponent,
        {
          data: {
            resolve: resolveArray,
          },
          hasBackdrop: true,
          width: '500px',
        }
      );
      DashboardResolvedModel.afterClosed().subscribe((doAction) => {
        if (!doAction) {
          this.reloadAllAlert();
        }
      });
    } else {
      this.toaster.error('Please select Atleast one alert');
    }
  }

  enableAll() {
    const pktData = {
      pk: (this.isFilterApplied ? this.filteredTableData : this.tableData)
        .filter(({ isSelected }) => isSelected)
        .map(({ primaryKey }) => primaryKey),
    };
    if (pktData.pk.length != 0) {
      this.posHttpSvcs
        .authPost('v1/ui/enableAlerts', 'enableAlerts', pktData)
        .subscribe((resp) => {
          if (resp.isError) {
            this.toaster.error(resp.data);
            return;
          } else {
            this.toaster.success(resp.data);
            this.reloadAllAlert();
            this.disablePage = false;
          }
        });
    } else {
      this.toaster.error('Please select Atleast one alert');
    }
  }

  disableAll() {
    const pkArray: number[] = (this.isFilterApplied ? this.filteredTableData : this.tableData)
      .filter((data) => data.isSelected)
      .map((data) => data.primaryKey);

    if (pkArray.length != 0) {
      const DashboardDisabledModel = this.fnModalSvcs.openCustomModal(
        DashboardDisableModelComponent,
        {
          data: {
            pk: pkArray,
          },
          hasBackdrop: true,
          width: '500px',
        }
      );
      DashboardDisabledModel.afterClosed().subscribe((doAction) => {
        if (!doAction) {
          this.reloadAllAlert();
        }
      });
    } else {
      this.toaster.error('Please select Atleast one alert');
    }
  }

  ngOnDestroy(): void {
    if (this.interval != null) {
      clearInterval(this.interval);
    }
    if (this.interval1 != null) {
      clearInterval(this.interval1);
    }
    this.loader.setloaderType(FnLoaderType.AUTO);
  }
}
